
import React from 'react';
import ReactDOM from 'react-dom';
import swal from 'sweetalert';

class ProductsRegister extends React.Component
{
    constructor(props) {
        super(props);

        this.handleChange = this.handleChange.bind(this);
        this.save = this.save.bind(this);

        this.state = {
            product: {},
            successRegister: false
        };
    }

    componentWillMount()
    {
        let self = this;
    }

    componentDidMount()
    {
        let self = this;
        $('#expiration_date').prop('disabled', true);
    }


    handleChange({target}) {
        let self = this;

        let product = self.state.product;
        product[target.id] = target.value;

        self.setState({
            product: product
        });
    }

    save()
    {
        let self = this;
        let request = self.state.product;

        axios.post('/api/products/register/' + project, request)
            .then(response => {
                $('#productRegisterButton').remove();
                $("#productForm :input").attr("disabled", true);

                self.setState({
                    successRegister: true
                });

                swal({
                    title: "¡Producto registrado!",
                    text: "El producto ha sido registrado exitosamente.",
                    icon: "success",
                });
            })
            .catch(error => {
            });
    }

    expirationChange(flag)
    {
        let self = this;
        let checkYes = $("#expirationYes");
        let checkNo = $("#expirationNo");
        let inputExp = $('#expiration_date');

        if (!flag) {
            checkNo.prop("checked", false);
            checkYes.prop("checked", true);
            inputExp.prop("disabled", false);

            let product = self.state.product;
            product['expiration'] = 1;
            self.setState({
                product: product
            });

        } else {
            $("#expirationNo").prop("checked", true);
            $("#expirationYes").prop("checked", false);
            inputExp.prop("disabled", true);

            let product = self.state.product;
            product['expiration'] = 0;
            self.setState({
                product: product
            });

        }
    }

    render()
    {
        return (
            <div>
                <div className="container">
                    <div className="row">
                        <div className="col-md-4 col-md-offset-4 col-sm-8 col-sm-offset-2 col-xs-12">
                            <div className="panel panel-default">
                                <div className={"panel-header"}>
                                    <div className={"row"}>
                                        <div className="col-md-6 col-md-offset-3" style={{ paddingTop: "25px", paddingBottom: "25px" }}>
                                            <img src="../img/products.png" className="img-responsive" />
                                        </div>
                                    </div>
                                </div>
                                <div className="panel-body">
                                    <div className="col-md-12">
                                        <h4 className="m-t-0 header-title"><b>Registro de un Producto</b></h4>
                                        <form role="form" id="productForm">
                                            <div className="form-group">
                                                <label htmlFor="key">Nombre</label>
                                                <input type="text" className="form-control" id="key" onChange={this.handleChange}/>
                                            </div>
                                            <div className="form-group">
                                                <label htmlFor="description">Descripción</label>
                                                <textarea className="form-control" id="description" onChange={this.handleChange}/>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label>¿El producto tiene caducidad?</label>
                                                    <div className="checkbox checkbox-danger">
                                                        <input type="checkbox" id="expirationYes"
                                                               onChange={this.expirationChange.bind(this, false)} />
                                                        <label id="expirationYes">Si</label>
                                                    </div>
                                                    <div className="checkbox checkbox-info">
                                                        <input type="checkbox" id="expirationNo"
                                                               onChange={this.expirationChange.bind(this, true)}/>
                                                        <label id="expirationNo">No</label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label htmlFor="expiration_date">Caducidad</label>
                                                    <input type="date" className="form-control" id="expiration_date" onChange={this.handleChange} />
                                                </div>
                                            </div>
                                            <div className="clearfix"></div>
                                            <div className="form-group">
                                                <label htmlFor="commerce">Comercio</label>
                                                <input type="text" className="form-control" id="commerce" onChange={this.handleChange}/>
                                            </div>
                                            <div className="form-group">
                                                <label htmlFor="contact">Contacto</label>
                                                <input typeof="date" className="form-control" id="contact" onChange={this.handleChange}/>
                                            </div>
                                            <div className="form-group">
                                                <label htmlFor="notes">Notas *</label>
                                                <textarea className="form-control" id="notes" onChange={this.handleChange} />
                                            </div>
                                            <small>* - Campo NO obligatorio</small>
                                            <button type="button" className="btn btn-purple waves-effect waves-light pull-right"
                                                    id="productRegisterButton" onClick={this.save} disabled={!this.state.product.key ||
                                                    !this.state.product.description || !this.state.product.commerce || !this.state.product.contact}>
                                                <i className="fa fa-save"></i> Guardar
                                            </button>
                                        </form>
                                        {
                                            this.state.successRegister &&
                                            <div>
                                                <a href="/products" className="btn btn-success waves-effect waves-light pull-right">
                                                    <i className="fa fa-arrow-circle-o-left"></i> Regresar a productos
                                                </a>
                                            </div>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default ProductsRegister;

if (document.getElementById('products_register-component')) {
    ReactDOM.render(<ProductsRegister />, document.getElementById('products_register-component'));
}



// WEBPACK FOOTER //
// ./resources/assets/react/ProductsRegister.jsx